module.exports = __webpack_public_path__ + "img/k5.02326043.webp";